import { lightTheme } from './defaultTheme';

/** @deprecated Prefer `lightTheme` / `darkTheme` from `./defaultTheme`. */
export const colors = lightTheme.colors;
export const radii = lightTheme.radii;
export const spacing = lightTheme.spacing;
export const typography = lightTheme.typography;
